import DocumentsList from "./DocumentsList";

export default DocumentsList;


// WEBPACK FOOTER //
// ./resources/assets/js/components/DocumentsList/index.js